<template>
  <span>
    <v-tooltip v-if="disabled && disabledReason" location="bottom">
      <template #activator="{ props: tipProps }">
        <span v-bind="tipProps">
          <v-btn
            color="red-darken-3"
            variant="flat"
            :loading="loading"
            :disabled="disabled"
            :block="block"
            :class="btnClass"
            @click="openInbox"
          >
            <v-icon start>mdi-message-text-outline</v-icon>
            {{ $t('whatsappInbox.open') }}
          </v-btn>
        </span>
      </template>
      {{ disabledReason }}
    </v-tooltip>
    <v-btn
      v-else
      color="red-darken-3"
      variant="flat"
      :loading="loading"
      :disabled="disabled"
      :block="block"
      :class="btnClass"
      @click="openInbox"
    >
      <v-icon start>mdi-message-text-outline</v-icon>
      {{ $t('whatsappInbox.open') }}
    </v-btn>
  </span>
</template>

<script>
import postRequest from '@/api/postRequest';
import { hasPortalPermission, PORTAL_PERMISSIONS } from '@/utils/portalPermissions';

export default {
  name: 'WhatsappInboxButton',
  props: {
    institutionId: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledReason: {
      type: String,
      default: '',
    },
    block: {
      type: Boolean,
      default: false,
    },
    btnClass: {
      type: String,
      default: '',
    },
  },
  emits: ['error'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    canOpen() {
      return hasPortalPermission(this.$store, PORTAL_PERMISSIONS.WHATSAPP_INBOX);
    },
    async openInbox() {
      if (!this.canOpen() || this.disabled) {
        return;
      }
      const popup = window.open('about:blank', '_blank');
      this.loading = true;
      try {
        const body = {};
        if (this.institutionId) {
          body.institution_id = this.institutionId;
        }
        const res = await postRequest.object('/whatsapp/inbox-token', body);
        const url = res.data && res.data.url;
        if (!url) {
          throw new Error('missing_url');
        }
        if (popup) {
          popup.location.href = url;
        } else {
          window.open(url, '_blank');
        }
      } catch (err) {
        if (popup) {
          popup.close();
        }
        const status = err.response && err.response.status;
        let message = this.$t('whatsappInbox.errorGeneric');
        if (status === 404) {
          const data = err.response && err.response.data;
          if (data && data.code === 'no_whatsapp_number') {
            message = this.$t('whatsappInbox.errorNoNumber');
          } else {
            message = this.$t('whatsappInbox.errorNoNumber');
          }
        } else if (status === 403) {
          message = this.$t('whatsappInbox.errorForbidden');
        } else if (status === 503) {
          message = this.$t('whatsappInbox.errorNotConfigured');
        }
        this.$emit('error', { message, color: 'error' });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
